const repDomCoords = {
  latitude: 18.7357,
  longitude: -70.1627
}

export default repDomCoords;
